// generated from 2 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const totalRevenueFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("total_revenue_filter"),
  comparison_key: z.literal("3"),
  display_name: z.string(),
  raw_value: z.literal(0),
  value: z.literal(0),
  varies_by_app_group: z.literal(false),
});
